import { forEach } from 'lodash';
import Bignumber from 'bignumber.js';
import {
  FETCH_FILTER_ORDER_HISTORY,
  FETCH_FILTER_ORDER_HISTORY_FAILED,
  FETCH_FILTER_ORDER_HISTORY_SUCCEED,
  FETCH_USER_OPEN_ORDER_HISTORY_SUCCEED,
  FETCH_USER_ORDER_HISTORY_SUCCEED,
} from '../actions/order_history/action_types';
import utils from '../../common/utils';

export default (
  state = {
    orderHistory: [],
    orderPairs: [],
    openOrders: [],
    totalCount: 0,
  }, action,
) => {
  switch (action.type) {
    // fetch order history
    case FETCH_FILTER_ORDER_HISTORY:
      return {
        ...state,
      };
    case FETCH_FILTER_ORDER_HISTORY_SUCCEED:
      forEach(action.params.data || [], (item) => {
        const amount = new Bignumber(item.quantity).plus(item.executed_quantity);
        item.pairs = `${item.coin}/${item.currency}`;
        item.amount = utils.formatCurrency(amount);
        item.total = utils.formatCurrency(amount.multipliedBy(item.price));
        item.executed_quantity = utils.formatCurrency(item.executed_quantity);
      });
      return {
        ...state,
        orderHistory: action.params.data,
        totalCount: action.params.totalCount,
      };
    case FETCH_USER_ORDER_HISTORY_SUCCEED:
      forEach(action.params.data || [], (item) => {
        const amount = new Bignumber(item.quantity).plus(item.executed_quantity);
        item.pairs = `${item.coin}/${item.currency}`;
        item.amount = utils.formatCurrency(amount);
        item.total = utils.formatCurrency(amount.multipliedBy(item.price));
        item.executed_quantity = utils.formatCurrency(item.executed_quantity);
      });
      return {
        ...state,
        orderHistory: action.params.data,
        totalCount: action.params.totalCount,
      };
    case FETCH_USER_OPEN_ORDER_HISTORY_SUCCEED:
      console.log(action.data, ': action.params.data src/redux/reducers/order_history_reducer.js:54');
      forEach(action.data || [], (item) => {
        const amount = new Bignumber(item.quantity).plus(item.executed_quantity);
        item.pairs = `${item.coin}/${item.currency}`;
        item.amount = utils.formatCurrency(amount);
        item.total = utils.formatCurrency(amount.multipliedBy(item.price));
        item.executed_quantity = utils.formatCurrency(item.executed_quantity);
      });
      return {
        ...state,
        openOrders: action.data,
      };
    case FETCH_FILTER_ORDER_HISTORY_FAILED:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};
